export default {"src":"/_next/static/media/gulu-dp.18594f5b.svg","height":115,"width":104,"blurWidth":0,"blurHeight":0};